module.exports = __webpack_public_path__ + "static/media/car.6c95e679.svg";